"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testAll = exports.isOver = exports.create = exports.isMouseCapturedByMouseArea = void 0;
var rogueGamepad_1 = require("../input/rogueGamepad");
var rogueMouse_sidecar_1 = require("../input/rogueMouse-sidecar");
var rogueCursor_sidecar_1 = require("../ui/rogueCursor-sidecar");
var objs = [];
var _isMouseCapturedByMouseArea = false;
var isMouseCapturedByMouseArea = function () {
    return _isMouseCapturedByMouseArea;
};
exports.isMouseCapturedByMouseArea = isMouseCapturedByMouseArea;
var create = function (x, y, w, h, hover, click) {
    var c = {
        x: x,
        y: y,
        w: w,
        h: h,
        hover: hover,
        click: click,
    };
    objs.push(c);
    return c;
};
exports.create = create;
var isOver = function (x, y, w, h) {
    var _a = rogueCursor_sidecar_1.rogueCursor.getMouseGridXY(), gridX = _a.gridX, gridY = _a.gridY;
    if (gridX >= x && gridX < x + w && gridY >= y && gridY < y + h) {
        return true;
    }
    return false;
};
exports.isOver = isOver;
var testAll = function () {
    var result = false;
    var _a = rogueCursor_sidecar_1.rogueCursor.getMouseGridXY(), gridX = _a.gridX, gridY = _a.gridY;
    var cursor = 'default';
    _isMouseCapturedByMouseArea = false;
    while (objs.length > 0) {
        var item = objs.pop();
        if (!item) {
            break;
        }
        if (gridX >= item.x &&
            gridX < item.x + item.w &&
            gridY >= item.y &&
            gridY < item.y + item.h) {
            if (rogueMouse_sidecar_1.rogueMouse.getInput().left === rogueGamepad_1.InputState.JustDown && item.click) {
                item.click();
            }
            else {
                if (item.hover) {
                    item.hover();
                }
            }
            _isMouseCapturedByMouseArea = true;
            cursor = 'pointer';
            result = true;
            break;
        }
    }
    var el = document.getElementById('phaser-root');
    if (el) {
        el.style.cursor = cursor;
    }
    return result;
};
exports.testAll = testAll;
